import styled from "styled-components"
// import "../CSS/Name.css"
// import Typical from "react-typical"
import { Box, Button, ButtonGroup, Link as ChakraLink, Flex, Heading, Text } from '@chakra-ui/react'
import { useContext } from "react"
import { ColorContext } from "../Context/ColorContext"



function Name() {
    const {colors,setColors,underLineColor,textColor} = useContext(ColorContext)

    const OpenPDF = () => {

        const url = `https://drive.google.com/file/d/126nip9sVVPZDBt2c2yXcxlDXK0e6Pevf/view?usp=share_link`

        window.open(url, '_blank');



    }

    const family = `system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;`

    return (
        <Box>
            <Box className="detel" mt={'5%'} pt={'5%'} fontFamily={family}>

                {/* <Typical steps={['I,M Bharat Sharma',8000,'A Full Stack Developer',2000]} loop={Infinity} wrapper="h1"/> */}
                <Flex  alignItems={'center'} justifyContent={['center','center','center', "left"]}><Heading  color={textColor} fontWeight={'700'} fontSize={['2rem','2.5rem','3.2rem','3.8rem']} mb={'20px'}>I'M&nbsp;</Heading> <Heading textAlign={['center','center','center','left']} fontWeight={'700'} fontSize={['2rem','2.5rem','3.2rem','3.8rem']} mb={'20px'} color={colors} id="user-detail-name"> Bharat Sharma</Heading></Flex>

                <Text textAlign={['center','center','center','left']} color={textColor} fontSize={['0.9rem','1rem','1.1rem','1.2rem']} fontWeight={'500'} id="user-detail-intro">This is my official Portfolio website to showcase my
                    all works related to <Text display={['inline','inline','block','block']}>web development and ui design.</Text> </Text>
                <Button display={['block','block','block','inline']} m={'auto'} fontSize={['1rem','1rem','1.2rem','1.5rem']} border={'none'} mt={'1%'} fontWeight={'600'} p={['0% 2%','0% 2%','0% 2%','0% 2%']} id="resume-button-2"  onClick={OpenPDF} color={'white'} bgColor={colors}> Resume </Button>
            </Box>
            {/* </div><ChakraLink id="resume-link-2" isExternal href='Bharat-sharma-resume.pdf' download="Bharat-sharma-resume.pdf" backgroundColor={"orange"}>Resume</ChakraLink> */}
        </Box>
    )

}





export default Name